import { db } from "services/firebase";
import firebase from "firebase/compat/app";

/**
 * Marks FDE role orientation complete on the signed-in user's profile.
 * Uses roleOnboarding (separate from account-level onboarding boolean).
 */
export async function markRoleOrientationComplete({ tciManager = false, fdeC = false } = {}) {
  const user = firebase.auth().currentUser;
  if (!user?.uid) {
    throw new Error("You must be signed in to complete orientation.");
  }

  const updates = {
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  };
  if (tciManager) {
    updates["roleOnboarding.tciManagerComplete"] = true;
  }
  if (fdeC) {
    updates["roleOnboarding.fdeCComplete"] = true;
  }
  if (Object.keys(updates).length <= 1) {
    throw new Error("No orientation completion flags were provided.");
  }

  await db.collection("users").doc(user.uid).update(updates);
}

/**
 * Soft Module 4 readiness — does not block annotation.
 * Pilot TCIs: triage, differential, medrec-intake.
 */
export const PILOT_MODULE4_TCIS = ["triage", "differential", "medrec-intake"];

export function isModule4CompleteForTci(userData, tciId) {
  if (!tciId) return true;
  const map = userData?.roleOnboarding?.module4CompleteByTci || {};
  return map[tciId] === true;
}

export function incompleteModule4TciIds(userData, tciIds = []) {
  return (tciIds || []).filter(
    (tciId) => PILOT_MODULE4_TCIS.includes(tciId) && !isModule4CompleteForTci(userData, tciId),
  );
}

export async function markModule4CompleteForTci(tciId) {
  const user = firebase.auth().currentUser;
  if (!user?.uid) {
    throw new Error("You must be signed in to complete Module 4.");
  }
  if (!tciId) {
    throw new Error("tciId is required.");
  }
  await db.collection("users").doc(user.uid).update({
    [`roleOnboarding.module4CompleteByTci.${tciId}`]: true,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export function needsTciManagerOrientation(userData) {
  return userData?.roleOnboarding?.tciManagerComplete === false;
}

export function needsFdeCOrientation(userData) {
  return userData?.roleOnboarding?.fdeCComplete === false;
}
